import { showDialogOverlay, hideDialogOverlay } from "../../../utils/dialogOverlay.js";

const API = "/api";
const EMPTY_TEXT = "\u2014";
let didBind = false;

function ensureUyeliklerOverviewDialog() {
	if (document.getElementById("uyeliklerOverviewDialog")) return;
	document.body.insertAdjacentHTML("beforeend", `
<dialog id="uyeliklerOverviewDialog">
    <div class="uyelikler-overview-container">
        <div class="uyelikler-overview-header">
            <div class="uyelikler-overview-header-text">
                <h2 class="uyelikler-overview-title"></h2>
                <span class="uyelikler-overview-id"></span>
            </div>
            <button class="uyelikler-overview-close">&#10005;</button>
        </div>
        <div class="uyelikler-overview-body">
            <div class="overview-section">
                <div class="overview-section-header">\u00dcyelik Bilgileri</div>
                <div class="overview-section-body uyelikler-overview-grid"></div>
            </div>
        </div>
        <div class="overview-footer">
            <button class="uyelikler-overview-close-btn">Kapat</button>
        </div>
    </div>
</dialog>`);
}

export function initUyeliklerOverviewDialog() {
	ensureUyeliklerOverviewDialog();
	const dialog = document.querySelector("#uyeliklerOverviewDialog");
	if (!dialog || didBind) return;
	didBind = true;

	window.openUyeliklerOverviewDialog = async (id) => {
		clearDialog(dialog);
		dialog.showModal();
		showDialogOverlay(dialog, "Y\u00fckleniyor...");
		await new Promise((r) => setTimeout(r, 350));
		try {
			const res = await fetch(`${API}/uyeler/${encodeURIComponent(id)}`);
			if (!res.ok) throw new Error(`HTTP ${res.status}`);
			const data = await res.json();
			fillDialog(dialog, data);
		} catch (err) {
			console.error("Uye overview yuklenemedi:", err);
		} finally {
			hideDialogOverlay();
		}
	};

	document.body.addEventListener("click", (e) => {
		if (e.target.closest(".uyelikler-overview-close") || e.target.closest(".uyelikler-overview-close-btn")) {
			dialog.close();
		}
	});
}

const OVERVIEW_FIELDS = [
	"T.C. Kimlik No",
	"Email",
	"Yetki",
	"\u00dcyelik Durumu",
	"Kayit Tarihi",
];

function clearDialog(dialog) {
	dialog.querySelector(".uyelikler-overview-title").textContent = EMPTY_TEXT;
	dialog.querySelector(".uyelikler-overview-id").textContent = EMPTY_TEXT;
	dialog.querySelector(".uyelikler-overview-grid").innerHTML = OVERVIEW_FIELDS
		.map(
			(label) =>
				`<div class="overview-detail">
                    <span class="overview-detail-label">${label}</span>
                    <span class="overview-detail-value">${EMPTY_TEXT}</span>
                </div>`,
		)
		.join("");
}

function fillDialog(dialog, d) {
	dialog.querySelector(".uyelikler-overview-title").textContent =
		`${d.first_name ?? ""} ${d.last_name ?? ""}`.trim() || EMPTY_TEXT;
	dialog.querySelector(".uyelikler-overview-id").textContent = `#${d.id}`;
	dialog.querySelector(".uyelikler-overview-title").title = dialog.querySelector(".uyelikler-overview-title").textContent;
	dialog.querySelector(".uyelikler-overview-id").title = dialog.querySelector(".uyelikler-overview-id").textContent;

	const grid = dialog.querySelector(".uyelikler-overview-grid");
	const tarih = d.olusturma_tarihi
		? new Date(d.olusturma_tarihi).toLocaleDateString("tr-TR", { day: "2-digit", month: "2-digit", year: "numeric" })
		: EMPTY_TEXT;
	const rows = [d.kisi_tc, d.email, d.yetki_adi, d.is_active ? "Aktif" : "Pasif", tarih];
	[...grid.querySelectorAll(".overview-detail-value")].forEach((el, i) => {
		el.textContent = rows[i] ?? EMPTY_TEXT;
		el.title = el.textContent;
	});
}
